var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("基本信息")))])]), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      },
      rules: _vm.dataRule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("工号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.disabled ? "" : _vm.$t("请输入") + _vm.$t("工号"),
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.jobNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "jobNo", $$v);
      },
      expression: "form.jobNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("姓名"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("姓名"),
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号"),
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "mobile", $$v);
      },
      expression: "form.mobile"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件类型"),
      prop: "certificateType"
    }
  }, [!_vm.disabled ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("证件类型")
    },
    model: {
      value: _vm.form.certificateType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "certificateType", $$v);
      },
      expression: "form.certificateType"
    }
  }, _vm._l(_vm.certificateList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-input", {
    attrs: {
      value: _vm.form.certificateType == 1 ? _vm.$t("身份证") : _vm.form.certificateType == 2 ? _vm.$t("护照") : _vm.form.certificateType == 3 ? _vm.$t("港澳通行证") : _vm.form.certificateType == 4 ? _vm.$t("港澳居民居住证") : _vm.$t("台湾居民居住证"),
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件号"),
      prop: "certificateNo"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("证件号"),
      readOnly: _vm.disabled
    },
    on: {
      blur: _vm.certificateNoChange
    },
    model: {
      value: _vm.form.certificateNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "certificateNo", $$v);
      },
      expression: "form.certificateNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("性别"),
      prop: "sex"
    }
  }, [!_vm.disabled ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("性别")
    },
    model: {
      value: _vm.form.sex,
      callback: function ($$v) {
        _vm.$set(_vm.form, "sex", $$v);
      },
      expression: "form.sex"
    }
  }, _vm._l(_vm.sexList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1) : _c("a-input", {
    attrs: {
      value: _vm.form.sex == 1 ? _vm.$t("男") : _vm.$t("女"),
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("民族"),
      prop: "nation"
    }
  }, [!_vm.disabled ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("民族"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.nation,
      callback: function ($$v) {
        _vm.$set(_vm.form, "nation", $$v);
      },
      expression: "form.nation"
    }
  }, _vm._l(_vm.nationList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1) : _c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.form.entryAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "entryAt", $$v);
      },
      expression: "form.entryAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("邮箱"),
      "validate-status": _vm.email,
      help: _vm.email == "error" ? _vm.$t("请输入") + _vm.$t("正确的电子邮箱") : "",
      disabled: _vm.disabled
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.disabled ? "" : _vm.$t("请输入") + _vm.$t("邮箱"),
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("居住地址"),
      prop: "address"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("居住地址"),
      maxLength: 100,
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.address,
      callback: function ($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("银行卡号"),
      prop: "bankNo"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("银行卡号"),
      maxLength: 20,
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.bankNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "bankNo", $$v);
      },
      expression: "form.bankNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("开户行"),
      prop: "bank"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("开户行"),
      maxLength: 100,
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.bank,
      callback: function ($$v) {
        _vm.$set(_vm.form, "bank", $$v);
      },
      expression: "form.bank"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("入职日期"),
      prop: "entryAt"
    }
  }, [!_vm.disabled ? _c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("入职时间"),
      allowClear: "",
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.form.entryAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "entryAt", $$v);
      },
      expression: "form.entryAt"
    }
  }) : _c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.form.entryAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "entryAt", $$v);
      },
      expression: "form.entryAt"
    }
  })], 1)], 1)], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("职级信息")))])]), _c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("业务员类型"),
      prop: "resource"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.resource,
      callback: function ($$v) {
        _vm.$set(_vm.form, "resource", $$v);
      },
      expression: "form.resource"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("直辖")) + " ")]), _c("a-radio", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("非直辖")) + " ")])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("所属部门")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t("部门1"),
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("邀请人")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t("无"),
      maxLength: 100,
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("上级")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t("无"),
      maxLength: 100,
      readOnly: true
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否持证"),
      prop: "isCertificate"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.isCertificate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isCertificate", $$v);
      },
      expression: "form.isCertificate"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")]), _c("a-radio", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("业务员职级"),
      prop: "rank"
    }
  }, [!_vm.disabled ? _c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("业务员职级"),
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.form.rank,
      callback: function ($$v) {
        _vm.$set(_vm.form, "rank", $$v);
      },
      expression: "form.rank"
    }
  }, _vm._l(_vm.rankList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1) : _c("a-input", {
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.form.entryAt,
      callback: function ($$v) {
        _vm.$set(_vm.form, "entryAt", $$v);
      },
      expression: "form.entryAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("职业资格证号")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.certificateNum,
      callback: function ($$v) {
        _vm.$set(_vm.form, "certificateNum", $$v);
      },
      expression: "form.certificateNum"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      readOnly: _vm.disabled
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1)], 1), _vm.type != 1 ? _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center"
    }
  }, [_c("a-button", {
    attrs: {
      type: "add",
      loading: _vm.loading
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };